module.exports = __webpack_public_path__ + "img/logo-unipar-2.b1343c10.png";